module.exports = "@media only screen and (max-width: 600px) {\n  #content {\n    width: 100vw !important;\n    height: 100vh !important;\n    margin-top: 0 !important;\n    padding-top: 55px !important; }\n  .add {\n    height: 100vh !important; } }\n\n#content {\n  width: 50%;\n  max-width: 800px;\n  margin: 0 auto;\n  margin-top: 20vh; }\n\n.card-body {\n  padding: 35px !important; }\n\n.add {\n  background-color: rgba(255, 255, 255, 0.7) !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/add-poll/add-poll.component.scss
// module id = ./src/app/add-poll/add-poll.component.scss
// module chunks = main